export const MODULE_NAME = '@pressreader/commerce-core';
